// ZOD
import * as z from 'zod';
import { TechnoZod, TechnoType, TechnoSlugType, TechnoSlugZod } from '@/views/Techno/TechnoType';

// Strapi
import { blocks, seo } from '@/services/strapiPopulate';
import { fetchStrapiContentWithBlocks } from '@/services/blocks/fetchStrapiContentWithBlocks';

// Utils
import { formatZodError } from '@/utils/error';

// Client
import client from '../client';

export const getTechno = async (slug: string): Promise<TechnoType> =>
  fetchStrapiContentWithBlocks(`/api/technos/${slug}`, TechnoZod, { blocks, seo }, 'Techno Page');

export const getTechnos = async (): Promise<Array<TechnoSlugType>> => {
  const pageSize = 10;
  const response = await client.get('/api/technos', {
    params: {
      fields: ['slug'],
      populate: {
        seo,
      },
      pagination: {
        page: 1,
        pageSize,
      },
    },
  });

  const totalPages = response.data?.meta?.pagination.pageCount || 1;
  const allData = [...(response.data?.data ?? [])];

  try {
    if (totalPages > 1) {
      const pagePromises = Array.from({ length: totalPages - 1 }, (_, i) =>
        client.get('/api/technos', {
          params: {
            fields: ['slug'],
            populate: {
              seo,
            },
            pagination: { page: i + 2, pageSize },
          },
        }),
      );
      const results = await Promise.all(pagePromises);
      results.forEach((r) => allData.push(...(r.data?.data || [])));
    }

    return z.array(TechnoSlugZod).parseAsync(allData);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(`API response do not match Technos structure:\n${formatZodError(error, allData)}`);
    }
    throw error;
  }
};
